import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Container, Modal } from 'react-bootstrap'
import temple from 'assets/images/eventBoatRacing/imgTemple.png'
import treasureChest from 'assets/images/eventBoatRacing/imgTreasureChest.png'
import { useTranslation } from 'react-i18next'

function BigGoldPopupModal({ show, onHide, coin, ...otherProps }) {
	const { t } = useTranslation()

  useEffect(() => {
    let timeoutId;
    if (show) {
      timeoutId = setTimeout(() => {
        onHide()
      }, 3000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [show])

	return (
		<BaseModal
			show={show}
			onHide={onHide}
			hideDecor={true}
			congrats
			{...otherProps}
		>
			<Modal.Body className="py-0">
				<div className="d-flex justify-content-center align-items-center">
					<img src={temple} alt="Temple" />
				</div>

				<div className="d-flex justify-content-center align-items-center popup-content">
					<img srcSet={`${treasureChest} 2x`} alt="Treasure chest" />
					<p className="text-center popup-content-text text-large gold">
						{t('event.boat_racing.popup.reward.big_gold').replace(
							'_GOLD_',
							new Intl.NumberFormat().format(coin || 5000),
						)}
					</p>
				</div>
			</Modal.Body>
		</BaseModal>
	)
}

export default BigGoldPopupModal
